import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getClients } from "../api/clientApi";
import PageHeader from "../../../components/common/PageHeader";
import ClientTable from "../components/ClientTable";

const ClientList = () => {

  const [clients, setClients] = useState([]);
  const navigate = useNavigate();

  const loadClients = async () => {

const res = await getClients();

    setClients(res.data);
  };

  useEffect(() => {
    loadClients();
  }, []);

  return (
    <div className="p-6">

      <PageHeader
        title="Clients"
        action={
          <button
            onClick={() => navigate("/clients/new")}
            className="bg-indigo-600 text-white px-4 py-2 rounded"
          >
            Add Client
          </button>
        }
      />

      <ClientTable
        clients={clients}
        onRowClick={(id) => navigate(`/clients/${id}`)}
      />

    </div>
  );
};

export default ClientList;
